<div class="d-flex h-100 p-3 align-items-center" *ngIf="(totalDiscount$ | async) > 1">
    <div class="my-auto ml-auto">
        <span class="d-inline-block title">
            {{ "pt.edp.edponline.contract.header.no.savings.one" | translate }}
            <a class="d-inline-block title-amount" [routerLink]="[link]">{{ totalDiscount$ | async | number: '.2'  }}€ </a>
            {{ "pt.edp.edponline.contract.header.no.savings.two" | translate }}
        </span>
    </div>
    <div class="my-auto mr-auto">
        <span class="d-inline-block align-middle ml-2 mr-2">
            <i class="icon-edponline-Bop-086 icon-savings"  aria-hidden="true"></i>
        </span>
    </div>
</div>

<div class="d-flex h-100 p-3 align-items-center" *ngIf="(totalDiscount$ | async) < 1">
    <div class="my-auto ml-auto">
        <span class="title">{{ "pt.edp.edponline.contract.header.savings" | translate }}</span>
    </div>
    <div class="my-auto mr-auto">
        <a [routerLink]="[link]">
            <span class="d-inline-block align-middle ml-2">
                <i class="icon-edponline-Bop-073 rotate-270 icon-size"  aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>
